import { IDataRequest, IDataResponse, IHttpClient, STATUS_CODE } from "src/framework/providers/api";

type TipoUpload = "logo";
export interface IUploadData {
    url: string;
    tipo: TipoUpload;
    "@remove"?: boolean;
}

class ContaUploads {
    constructor(private readonly provider: IHttpClient, private readonly providerNoLoading: IHttpClient) { }

    async uploadImage({ userId, file, fileName, tipo = "logo", onProgress }: { userId: string, file: File, tipo: TipoUpload, fileName?: string, onProgress: (progress: number) => void }): Promise<IUploadData | null> {
        try {

            const _fileName = fileName ? fileName : "logo";

            const form = new FormData();
            const name: string[] = file.name.split(".");
            const extension: string | undefined = name.pop();
            if (extension) {
                form.append(`${tipo}.${extension}`, file, file.name);
                const request: IDataRequest = {
                    url: `/cadastros/contas/uploads/${userId}`,
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: form,
                    onUploadProgress: (progressEvent: any) => {
                        const progress: number = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                            );
                            onProgress(progress)
                        }
                    };
                    
                const response: IDataResponse = await this.providerNoLoading.post(request);
                if (response.statusCode === STATUS_CODE.OK) {
                    const idx = `${_fileName}.${extension}`;
                    return {
                        url: response.data[idx]["path"],
                        tipo: "logo",
                    }
                }

                return null;
            }

            return null;
        } catch (error) {
            return null;
        }
    }

    async removeUpload(codigoUpload: string): Promise<boolean> {
        try {

            return false;
        } catch (error) {
            return false;
        }
    }
}

export { ContaUploads }